

































import {
  Message, ShowFinally, HasTaskMixin, formatDateTime, formatDate,
} from 'mycorems-app-shared';
import eventBus from '../../messaging/event-bus';
import { SubscribedToAccount, UnsubscribedFromAccount } from '../../messaging/events';
import {
  AccountSubscriber, AccountSubscriberFilters, QueryResult, QPagination, User,
} from '../../types';
import repository from './client-subscriber-repository';
import SubscriptionToggle from './SubscriptionToggle.vue';

interface Data {
  accountSubscribers: AccountSubscriber[],
  columns: object[],
  pagination: QPagination,
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 5,
        rowsNumber: 0,
      },
      accountSubscribers: [],
      columns: [
        {
          name: 'name',
          label: 'Name',
          align: 'left',
          field: (as: AccountSubscriber) => `${as.user.firstName} ${as.user.lastName}`,
        },
        {
          name: 'email',
          label: 'Email',
          align: 'left',
          field: (as: AccountSubscriber) => as.user.email,
        },
        {
          name: 'subscribedAt',
          label: 'Subscribed',
          align: 'left',
          field: (as: AccountSubscriber) => as.subscribedAt,
        },
        {
          name: 'actions',
          label: '',
          align: 'right',
        },
      ],
    };
  },
  watch: {
    accountId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    pagination: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    offset(): number {
      return (this.pagination.page - 1) * this.pagination.rowsPerPage;
    },
    filters(): AccountSubscriberFilters {
      return {
        accountId: this.accountId,
        limit: this.pagination.rowsPerPage,
        offset: this.offset,
      };
    },
  },
  methods: {
    add(subscriber: AccountSubscriber): void {
      this.accountSubscribers.unshift(subscriber);
    },
    onUnsubscribe(user: User) {
      const index = this.accountSubscribers.findIndex(as => as.user.id === user.id);
      if (index >= 0) {
        this.accountSubscribers.splice(index, 1);
        this.pagination.rowsNumber -= 1;
      }
      this.$emit('unsubscribed', user);
    },
    load(): void {
      this.task = repository.findSubscribers(this.filters);
      this.task.then((result: QueryResult) => {
        this.accountSubscribers = result.items as AccountSubscriber[];
        this.pagination.rowsNumber = result.total;
      });
    },
    formatDateTime,
    formatDate,
  },
  created(): void {
    eventBus.$on(SubscribedToAccount.eventName, this.load);
    eventBus.$on(UnsubscribedFromAccount.eventName, this.load);
  },
  beforeDestroy(): void {
    eventBus.$off(SubscribedToAccount.eventName, this.load);
    eventBus.$off(UnsubscribedFromAccount.eventName, this.load);
  },
  components: {
    ShowFinally,
    Message,
    SubscriptionToggle,
  },
});
